import { Navigate } from 'react-router-dom';

export function OperationsPage() {
  return <Navigate to="/travel/operations/calendar" replace />;
}
